
import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import Referenciados from './Referenciados'
import Remitos from './Remitos'
import Conformidades from './Conformidades';
import Autorizaciones from './Autorizaciones';

export default function Documentos() {
    const [accion, setAccion] = React.useState('0');

    const handleChange = (event) => {
        setAccion(event.target.value);
      };
      
    return(
        <>
        <Box fullWidth  
        display="flex"
        alignItems="center"
        justifyContent="center">
        <FormControl sx={{ m: 1, minWidth: 200, marginBottom: '10px' }} size="small">            
            <InputLabel id="slAccion-lbl">Acción</InputLabel>
            <Select
                labelId="slAccion-lbl"
                id="slAccion"
                value={accion}
                label="Acción"
                onChange={handleChange}               
                sx={{ fontSize: 13 }}
            >
                <MenuItem value={0} sx={{ fontSize: 13 }}><strong><em>Seleccione una acción...</em></strong></MenuItem>
                <MenuItem value={1} sx={{ fontSize: 13 }}>Referenciados</MenuItem>
                <MenuItem value={2} sx={{ fontSize: 13 }}>Remitos</MenuItem>
                <MenuItem value={3} sx={{ fontSize: 13 }}>Autorizaciones</MenuItem>
                <MenuItem value={4} sx={{ fontSize: 13 }}>Conformidades</MenuItem>
            </Select>
        </FormControl>
        </Box>
        
            {accion === 0 &&  ''}
            {accion === 1 &&  <Referenciados/>}
            {accion === 2 &&  <Remitos/>}
            {accion === 3 &&  <Autorizaciones/>}
            {accion === 4 &&  <Conformidades/>}
            </>
    )
    }